<template>
  <div id="content">
    <div class="page-title">帮助指南
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">OPPO手机推送相关设置
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">在叮咚—App设置—开启通知权限里进行设置（以oppo reno ace为参考，Android11系统）</p>
      <img src="./oppo1.png" class="bg"/>
      <p class="page-title2">1.自启动管理权限去开启，关于启动的打开。</p>
      <img src="./oppo2.png" class="bg"/>

      <p class="page-title2">2.通知管理去开启，如下图2中，分别将设置项</p>
      <p class="page-title2">【普通】【重要】【DingDongApp-Channel】【DingDongUpdate-Channel】【系统默认通道】【系统静默通道】，参照下图3，将相关项开启。</p>

      <img src="./oppo3.png" class="bg"/>
      <p class="page-title2">3.其他权限：悬浮窗和锁屏显示按下图开启</p>
      <img src="./oppo4.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod 黑体;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/nobindmsg/oppo/oppo.vue